<template>
  <v-container fluid="fluid">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("labels.filters") }}</h1>
        </v-toolbar-title>
        <v-spacer> </v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn>
          </template>
          <span>Reset</span>
        </v-tooltip>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Fetch Data</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-container class="pa-0" fluid="fluid" grid-list-md="grid-list-md">
          <v-layout row="row" wrap="wrap" grid-list-md="grid-list-md">
            <v-flex xs6="xs6" sm3="sm3">
              <v-select
                v-model="filter.assignedTo"
                :items="AssignedUser"
                name="assigned-user"
                :loading="assignedLoading"
                clearable="clearable"
                item-text="fullName"
                item-value="userID"
                attach="attach"
                chips="chips"
                label="Assigned To"
                multiple="multiple"
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.fullName }}</span>
                  </v-chip>
                  <span class="grey--text caption" v-if="index === 1"
                    >(+{{ filter.assignedTo.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-flex>
            <v-flex xs6="xs6" sm3="sm3" v-if="ComboBox.length > 0">
              <v-select
                v-model="filter.ticketType"
                :items="comboBoxByID(4).ComboBoxDetails"
                clearable="clearable"
                :label="$t('labels.ticketType')"
                item-text="selector"
                item-value="id"
                attach="attach"
                chips="chips"
                multiple="multiple"
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.selector }}</span>
                  </v-chip>
                  <span class="grey--text caption" v-if="index === 1"
                    >(+{{ filter.ticketType.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-flex>
            <v-flex xs6="xs6" sm2="sm2" v-if="ComboBox.length > 0">
              <v-select
                v-model="filter.priority"
                :items="comboBoxByID(2).ComboBoxDetails"
                clearable="clearable"
                :label="$t('labels.priority')"
                item-text="selector"
                item-value="id"
                attach="attach"
                chips="chips"
                multiple="multiple"
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.selector }}</span>
                  </v-chip>
                  <span class="grey--text caption" v-if="index === 1"
                    >(+{{ filter.priority.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-flex>
            <v-flex xs6="xs6" sm4="sm4" v-if="ComboBox.length > 0">
              <v-select
                v-model="filter.status"
                :items="comboBoxByID(6).ComboBoxDetails"
                clearable="clearable"
                :label="$t('labels.status')"
                item-text="selector"
                item-value="id"
                attach="attach"
                chips="chips"
                multiple="multiple"
              >
                <template slot="selection" slot-scope="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item.selector }}</span>
                  </v-chip>
                  <span class="grey--text caption" v-if="index === 1"
                    >(+{{ filter.status.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container class="pa-0" fluid="fluid">
          <v-flex xs12="xs12" sm6="sm6">
            <VueCtkDateTimePicker
              v-model="setDate"
              label="Select Date Range"
              range="range"
              @input="setDateTime"
              overlay="overlay"
            >
            </VueCtkDateTimePicker>
          </v-flex>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.tickets") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line="single-line"
          hide-details="hide-details"
          clearable="clearable"
        >
        </v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="id"
        :items="tickets"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer" @click="props.expanded = !props.expanded">
            <td class="text-xs-left">
              {{ $moment(props.item.createdAt).format("MM/DD/YYYY h:m a") }}
            </td>
            <td
              class="text-xs-left"
              v-html="$options.filters.highlight(props.item.Store.CSPID, search)"
            >
              {{ props.item.Store.CSPID }}
            </td>
            <td
              class="text-xs-left"
              v-html="$options.filters.highlight(props.item.Store.businessName, search)"
            >
              {{ props.item.Store.businessName }}
            </td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.name, search)">
              {{ props.item.name }}
            </td>
            <td
              class="text-xs-left"
              v-html="$options.filters.highlight(props.item.phoneNumber, search)"
            >
              {{ props.item.phoneNumber }}
            </td>
            <td class="text-xs-left" v-html="$options.filters.highlight(props.item.title, search)">
              {{ props.item.title }}
            </td>
            <td
              class="text-xs-left"
              v-html="$options.filters.highlight(props.item.priorityDetail.selector, search)"
            >
              {{ props.item.priorityDetail.selector }}
            </td>
            <td
              v-html="$options.filters.highlight(props.item.assignedToUser.fullName, search)"
              class="text-xs-left"
              v-if="props.item.assignedToUser && props.item.assignedToUser.fullName"
            >
              {{ props.item.assignedToUser.fullName }}
            </td>
            <td class="text-xs-left" v-else>n/a</td>
            <td class="text-xs-left">
              <span>
                <StatusIndicator
                  class="mr-2"
                  negative="negative"
                  pulse="pulse"
                  v-if="
                    $moment(props.item.dueDate).format('MM/DD/YYY 23:59:59') <
                      $moment().format('MM/DD/YYYY 23:59:59')
                  "
                >
                </StatusIndicator>
              </span>
              <span>{{ $moment(props.item.dueDate).format("MM/DD h:m a") }}</span>
            </td>
            <td
              class="text-xs-left"
              v-html="$options.filters.highlight(props.item.statusDetail.selector, search)"
            >
              {{ props.item.statusDetail.selector }}
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-card>
            <v-card-text>
              <v-card class="elevation-15" dark color="#1B1B1D">
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-layout column>
                        <v-flex>
                          <h3 class="font-weight-bold mb-3" style="color: #21C593;">Ticket</h3>
                          <div class="font-weight-bold">{{ $t("labels.title") }}</div>
                          <div>{{ props.item.title }}</div>
                          <div class="mt-1 font-weight-bold">{{ $t("labels.description") }}</div>
                          <div class="">{{ props.item.description }}</div>
                          <div class="mt-1 font-weight-bold" v-if="props.item.solution">
                            {{ $t("labels.solution") }}
                          </div>
                          <div class="">{{ props.item.solution }}</div>
                        </v-flex>
                        <v-flex class="mt-3" v-if="props.item.softwareID === 54">
                          <h3 class="font-weight-bold mb-3" style="color: #21C593;">2.0 Software</h3>
                          <div class="font-weight-bold">Dropbox check</div>
                          <div v-if="!props.item.dropbox"><v-icon small color="red" >close</v-icon></div>
                          <div v-else><v-icon color="green" >mdi-check</v-icon></div>
                          <div class="mt-1 font-weight-bold">{{ $t("labels.version") }}</div>
                          <div v-if="props.item.version">{{ props.item.version }}</div>
                          <div v-else >N/A</div>
                          <div class="mt-1 font-weight-bold" v-if="props.item.solution">
                            {{ $t("labels.solution") }}
                          </div>
                          <div class="">{{ props.item.solution }}</div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <h3 class="font-weight-bold mb-3" style="color: #21C593;">Contact</h3>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.name") }}</div>
                      <div class="">{{ props.item.name }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.phoneNumber") }}</div>
                      <div>{{ props.item.phoneNumber }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.emailAddress") }}</div>
                      <div>{{ props.item.email }}</div>
                      <div class="mt-1 font-weight-bold">{{ $t("labels.status") }}</div>
                      <div>{{ props.item.statusDetail.selector }}</div>
                    </v-flex>

                    <v-layout row wrap>
                      <v-btn color="info" @click="gotoPage(props.item)">Go to page</v-btn>
                      <v-btn color="info" flat="flat" @click="gotoPageNewTab(props.item)">
                        <v-icon left="left">open_in_new </v-icon>Open in new tab</v-btn
                      >
                    </v-layout>
                  </v-layout>
                </v-container>
              </v-card>
            </v-card-text>
          </v-card>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import ticketService from "../service.js";
import userService from "../../User/service.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { StatusIndicator } from "vue-status-indicator";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
// import DateTimePicker from '../../Global/components/DateTimePicker'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      setDate: {
        start: null,
        end: null
      },
      filter: {
        assignedTo: [],
        status: [],
        ticketType: [],
        priority: [],
        fromDate: null,
        toDate: null
      },
      AssignedUser: [],
      TicketType: [],
      assignedLoading: true,
      headers: [
        {
          text: this.$t("labels.createdAt"),
          value: "createdAt",
          sortable: true
        },
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.storeName"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.name"),
          value: "name",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true
        },
        {
          text: this.$t("labels.title"),
          value: "title",
          sortable: true
        },
        {
          text: this.$t("labels.priority"),
          value: "priorityDetail.selector",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.assignedTo"),
          value: "assignedToUser.fullName",
          sortable: true
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          sortable: true
        },
        {
          text: this.$t("labels.status"),
          value: "statusDetail.selector",
          sortable: true
        }
      ],
      search: null,
      tickets: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: true
      }
    };
  },
  components: {
    VueCtkDateTimePicker,
    StatusIndicator
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["comboBox", "ComboBox", "comboBoxByID", "currentUser"])
  },
  async created() {
    await this.getAllUsers();
    console.log("this.$route.params", this.$route.params);
    if ((this.$route.params && this.$route.params.user) || this.$route.params.status) {
      if (this.$route.params.user) {
        this.filter.status = [];
        this.filter.status.push(48);
        this.filter.status.push(49);
        this.filter.status.push(51);
        this.filter.status.push(52);
        this.filter.assignedTo = [];
        this.filter.assignedTo.push(this.$route.params.user.userID);
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.setDate.start = null;
        this.setDate.end = null;
      }
      if (this.$route.params.status) {
        this.filter.status = [];
        this.filter.status.push(this.$route.params.status);
        this.filter.assignedTo = [];
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.setDate.start = null;
        this.setDate.end = null;
      }
    } else {
      await this.resetList();
    }
    await this.getList();
  },
  methods: {
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/tickets/profile/${data.id}` });
      window.open(routeData.href, "_blank");
    },
    setDateTime(val) {
      if (val) {
        if (val.start) this.filter.fromDate = val.start;
        if (val.end) this.filter.toDate = val.end;
      }
    },
    gotoPage(data) {
      this.$router.push({ path: `/tickets/profile/${data.id}` });
    },
    reset() {
      this.resetList();
      this.getList();
    },
    resetList() {
      this.filter.status = [];
      this.filter.status.push(48);
      this.filter.status.push(49);
      this.filter.status.push(51);
      this.filter.status.push(52);
      this.filter.assignedTo = [];
      this.filter.assignedTo.push(this.currentUser.userID);
      this.filter.fromDate = null;
      this.filter.toDate = null;
      this.setDate.start = null;
      this.setDate.end = null;
    },
    getAllUsers() {
      return userService.getAllCrmUser().then(result => {
        this.AssignedUser = result.data;
        this.assignedLoading = false;
        this.filter.assignedTo.push(this.currentUser.userID);
      });
    },
    reloadData() {
      this.loading = true;
      console.log("this.filter.ticketType.length > 0", this.filter.ticketType.length > 0);
      let proFilter = {};
      if (this.filter.assignedTo.length > 0)
        proFilter.assignedTo = this.filter.assignedTo.toString();
      if (this.filter.status.length > 0) proFilter.status = this.filter.status.toString();
      if (this.filter.ticketType.length > 0)
        proFilter.ticketType = this.filter.ticketType.toString();
      if (this.filter.priority.length > 0) proFilter.priority = this.filter.priority.toString();
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a");
      if (this.filter.toDate)
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a");
      console.log("proFilter in load data", proFilter);
      return ticketService.getAll(proFilter).then(response => {
        console.log("test reatesdfadfasdfsaf", response);
        this.tickets = response.data;
        this.loading = false;
        return response;
      });
    },
    getList() {
      console.log("this.currentUser", this.currentUser.userID);
      this.loading = true;
      let proFilter = {
        assignedTo: this.filter.assignedTo.toString(),
        status: this.filter.status.toString()
      };
      console.log("proFilter", proFilter);
      ticketService.getAll(proFilter).then(response => {
        console.log("ticet response", response);
        this.tickets = response.data;
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped></style>
